import React, { ReactElement } from 'react';
import styles from './SourceBlock.module.scss';
import { ISource } from "@common/redux/types/common";

interface IProps {
  source: ISource
}

export const SourceBlock = ({ source }: IProps): ReactElement => {
  if (source.name !== 'eipsk') {
    return <></>
  }

  return (
    <div className={styles.source_wrapper}>
      <div className={styles.source_inner}>
        <span className={styles.source_hint}>
          Источник:&nbsp;
        </span>
        <span className={styles.source_href}>
          <a href={'https://www.culture.ru/'}>
              Культура.РФ
          </a>
        </span>
      </div>
    </div>
  )
}
